module.exports = __webpack_public_path__ + "static/media/user-login-activity-tracker-logo.e4573c9a.png";